// extracted by mini-css-extract-plugin
module.exports = {"statewise-link":"StatewiseData_statewise-link__3fvcY","statewise-row":"StatewiseData_statewise-row__2R_GF"};